// Deep links out to AWS and Observer, kept out of the components that render
// them.

import getEnvironment from '../../utils/getCurrentEnv';

const ONE_MINUTE = 60000;

export const traceIdOf = (log) =>
  log?.response_from_cache
    ? log?.parent_x_decisiv_trace_id || log?.x_decisiv_trace_id
    : log?.x_decisiv_trace_id;

// The ARN is a backend-issued AWS ARN sitting in the console's hash path, where
// Step Functions expects it verbatim — URL-encoding the colons breaks the
// deep-link — so only the query-string values are encoded.
export const formatLogUrl = (logInfo) => {
  const arn = logInfo?.execution_arn;
  const region = process.env.REACT_APP_AWS_REGION;
  const regionParam = encodeURIComponent(region);
  const base = `https://${region}.console.aws.amazon.com/states/home?region=${regionParam}`;

  if (!arn?.includes('http-api-request')) {
    return `${base}#/v2/executions/details/${arn}`;
  }

  // Express executions are addressed by ARN plus the start time. A missing or
  // unparseable date used to reach the URL as `startDate=NaN`; the param is
  // dropped instead, which lands the user on the console rather than on a
  // malformed link. Substituting "now" would be worse — it looks valid and
  // silently points at the wrong window.
  const startedAt = new Date(logInfo?.start_date).getTime();
  if (Number.isNaN(startedAt)) {
    return `${base}#/express-executions/details/${arn}`;
  }

  return `${base}#/express-executions/details/${arn}?startDate=${encodeURIComponent(
    startedAt,
  )}`;
};

// A cached response has no log lines of its own, so the window is taken from the
// execution that populated the cache.
export const formatRequestDetailUrl = (logInfo, parentLog) => {
  const sourceLog =
    logInfo?.response_from_cache && parentLog ? parentLog : logInfo;

  const startDateTimestamp = sourceLog?.start_date
    ? new Date(sourceLog.start_date).getTime() - ONE_MINUTE
    : new Date().getTime() - ONE_MINUTE;
  const endDateTimestamp = sourceLog?.stop_date
    ? new Date(sourceLog.stop_date).getTime() + ONE_MINUTE
    : startDateTimestamp + ONE_MINUTE;

  const params = new URLSearchParams({
    orgId: '1',
    'var-service': 'integration-framework',
    'var-env': getEnvironment(process.env.REACT_APP_BASE_URL),
    'var-trace_id': traceIdOf(logInfo),
    from: startDateTimestamp,
    to: endDateTimestamp,
  });

  return `${process.env.REACT_APP_OBSERVER_TRACE_EXPLORER_URL}?${params}`;
};
